import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Form, Input, Popconfirm, Button, message, notification } from 'antd';
import * as _ from 'lodash';
import { projectService } from '../../../services/projectService';
import { fileService } from '../../../services/fileService';
import { folderService } from '../../../services/folderService';

const Rename = ({dlObject, hideModal, angularScope, view}) => {

  const inputRef = useRef();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [changedExt, setChangedExt] = useState(false);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      inputRef.current.focus();
      inputRef.current.setSelectionRange(0, dlObject.Name.length);
    }, 100)
  }, [dlObject, inputRef])

  const processResponse = useCallback((res) => {
    if(res.data.Error) {
      message.error({content: res.data.Message}),
      setLoading(false),
      setDisabled(false)
    } else {
      hideModal();
      angularScope.$broadcast('reloadGrid');
      notification.success({message: 'Renamed 1 item'});
    }
  }, [angularScope, hideModal])

  const handleSubmit = useCallback(() => {

    setLoading(true);
    setDisabled(true);

    const isFolder = !dlObject.Type;
    const initialValue = dlObject.Name;

    const newName = form.getFieldValue('newName');

    if (view.toLowerCase() === 'projects' && isFolder) {

      if (newName.length > 50) {
          message.error({content: 'The name has exceeded the maximum length of 50 characters.'});
      } else {

        if (initialValue === newName) { return false; }

        projectService.rename(dlObject.ID, newName).then(res => {
          processResponse(res);
        })
      }
    } 
    else {

      if (!dlObject.Type) {
        folderService.rename(dlObject.ID, newName).then(res => {
          processResponse(res);
        })
      }
      else {

        var newBase = newName.substr(0, newName.lastIndexOf('.'));
        var newExt = newName.substr(newName.lastIndexOf('.') + 1);

        fileService.rename(dlObject.ID, newExt, newBase).then(res => {
          processResponse(res);
        })
      }
    }
  }, [dlObject, view, form, processResponse])

  const onChange = useCallback((field) => {

    const nameField = field[0].value;
    setDisabled(nameField === dlObject.Name);

    if(dlObject.Type) {
      const newExt = nameField.substr(nameField.lastIndexOf('.') + 1);
      setChangedExt(dlObject.Type !== newExt);
    }

  }, [dlObject])

  return (
    <Container>
      <Form
        form={form}
        labelAlign="left"
        onFieldsChange={onChange}
        initialValues={{newName: dlObject.Type ? `${dlObject.Name}.${dlObject.Type}` : dlObject.Name}}
      >
        <Form.Item
          label=""
          name="newName"
          rules={[{required: true, message: 'New name required'}]}
        >
          <Input ref={inputRef} />
        </Form.Item>

        <Form.Item
          style={{ marginTop: '25px' }}
        >
          <Popconfirm
            title="Warning"
            description={`Changing the file extension will cause problems when launching the document.
                          Rendered documents extensions will not be changed.
                          Are you sure you wish to continue?`}
            onConfirm={handleSubmit}
            onCancel={hideModal}
            placement="topRight"
            disabled={!changedExt}
          >
            <Button
              type="primary"
              htmlType="submit"
              style={{ float: 'right', marginLeft: '10px' }}
              disabled={disabled}
              onClick={!changedExt ? handleSubmit : () => {}}
              loading={loading}
            >
              Save
            </Button>
          </Popconfirm>
          <Button
            style={{ float: 'right' }}
            onClick={hideModal}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`

const mapStateToProps = state => {
  const { view } = state.workingFolder;
  return { view };
}
export default connect(mapStateToProps)(Rename);